import { render } from "./CathayFlexFilmCover.vue?vue&type=template&id=eac7da96"
const script = {}

import "./CathayFlexFilmCover.vue?vue&type=style&index=0&id=eac7da96&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__